import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { TransfersService } from '@core/services/transfers.service';
import { ValidationsService } from '@core/services/validations.service';
import { TransfersListComponent } from '@modules/transfers/transfers-list/transfers-list.component';
import { Constants } from '@shared/class/constants.class';
import { SearchReference } from '@shared/interfaces/transfer';

@Component({
  selector: 'app-transfers-reference-filter',
  templateUrl: './transfers-reference-filter.component.html'
})
export class TransfersReferenceFilterComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public transferForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    public transfersService: TransfersService,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {
    this.transferForm = new FormGroup({
      reference: new FormControl('', [
        Validators.required,
        ValidationsService.isInvalidNumberValidator
      ])
    });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.transferForm;
    if (form.dirty && form.valid) {
      const formData: SearchReference = {
        channel: this.appConfig.CHANNEL,
        reference: form.value.reference,
        user: this.generalsService.getUserName()
      };

      this.generalsService.openTransfer(formData, TransfersListComponent);
    }
  }
}
